import { fetchAPI } from "./baseApi";

// Logostrip Section CRUD
export async function getLogostripSections() {
  return fetchAPI("/logostrip/sections/list", {
    method: "GET",
  });
}

export async function createLogostripSection(data) {
  return fetchAPI("/logostrip/sections", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateLogostripSection(id, data) {
  return fetchAPI(`/logostrip/sections/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deleteLogostripSection(id) {
  return fetchAPI(`/logostrip/sections/${id}`, {
    method: "DELETE",
  });
}

// Logostrip Item CRUD
export async function createLogostripItem(data) {
  return fetchAPI("/logostrip/items", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateLogostripItem(id, data) {
  return fetchAPI(`/logostrip/items/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deleteLogostripItem(id) {
  return fetchAPI(`/logostrip/items/${id}`, {
    method: "DELETE",
  });
}
